<template lang="pug">
.contentContainer
  h1.TitleU {{ name }}
  p {{discription[year]}}
  table
    thead
    tr.headRow
      th.headLabel(v-for="(el, key) in thList", :key="key") {{ el }}
    tbody
    tr(v-for="(el, key) in rowList[year]", :key="key")
      td
        strong {{ el.time }}
      td(style="white-space: pre-wrap;")
        strong {{ el.content }}
        p.tableCotent(v-if="el.more") {{ el.more }}
</template>

<script>
export default {
  props: ['year'],
  data() {
    return {
      name: "AGENDA",
      thList: ["Time", "Event"],
      discription: {
        2025: "The program on 10/13, in Espoo, Finland (GMT +3) time zone.",
        2024: "The program on 10/6, in Melbourne (GMT +10) time zone.",
        2023: "The program on 10/9, in Cancún (GMT -5) time zone.",
        2022: "The program on 9/11, in Cambridge (GMT+1) time zone.",
        2021: "The program on 9/26, in Taiwan (GMT+8) time zone."
      },
      rowList:
      {
        2025: [
          {time: "9:00 ~ 9:20",content: "Opening"},
          {time: "9:20 ~ 10:20",content: "Keynote Talk I",more: "Keynote Speaker: \n • Yunqi Guo (Chinese University of Hong Kong)"},
          {time: "10:20 ~ 10:40",content: "Coffee Break"},
          {time: "10:40 ~ 11:55",content: "Paper Session I",more:" • “Toward High Spatial Resolution and Low Ambiguity in Wideband Signal Receiver Beamforming for VR/AR”, Longyuan Ge, Juntao Zhou, Dian Ding, Yi-Chao Chen, Yu Lu, Yida Wang, Guangtao Xue\n • “Asymmetric MR Telecommunication System Using 3D Gaussian Splatting: Implementation and Technical Performance Evaluation”, Takashi Ota\n • “A sensory experience through the entanglement of dynamic virtual memories”, Marta Shilova, Hui-Ting Hong, Chu-Yin Chen, Ray-Kuang Lee"},
          {time: "11:55 ~ 14:00",content: "Lunch Break"},
          {time: "14:00 ~ 15:00",content: "Keynote Talk II",more: "Keynote Speaker: \n • Takayuki Hoshi (Pixie Dust Technologies, Inc.)"},
          {time: "15:00 ~ 15:20",content: "Break"},
          {time: "15:20 ~ 16:55",content: "Paper Session II & Discussion",more: " • “MARS: Robust Multi-View Acoustic Learning for Unsupervised Gesture Sensing in VR/AR Headsets”, Jiajun Yu, Bingzhi Wang, Yong Ma, Yongzhao Zhang, Jie Yang\n • “ShelfScan: An End-to-End Embodied Framework for Automated Library Book Inventory, Recognition, and Sorting”, Ling Ma, Sun Yi, Wanru Yang, Ding Yue, Cong Tian, Yahong Lu\n • “Immersive Bridge Inspection: Quantifying the Benefits of XR for Anomaly Detection”, Ali Sabzi Khoshraftar, Berend Jan van der Zwaag, Duc Viet Le, Ozlem Durmaz\n • Experience Sharing and Discussion Among All Authors"},
          {time: "16:55 ~ 17:15",content: "Coffee Break"},
          {time: "17:15 ~ 17:25",content: "Closing & Best Paper Award Ceremony",more: "Best Paper\n •   TBA"},
        ],
        2024: [
          {time: "9:00 ~ 9:20",content: "Opening"},
          {time: "9:20 ~ 10:30",content: "Keynote Talk I",more: " Keynote Speaker: \n • Shoichi Koyama (National Institute of Informatics, Japan)"},
          {time: "10:30 ~ 10:50",content: "Coffee Break"},
          {time: "10:50 ~ 12:05",content: "Paper Session I",more:" •  “HCMG: Human-Capacitance based Micro Gesture for VR/AR”, Yu Lu, Dian Ding, Ran Wang, Guangtao Xue\n • “DualStage : Synchronizing Onsite and Online Concerts for Enhanced Audience Interaction”, Tai-Chen Tsai, Yu-Hsuan Chen, Min-Chun Hu, Tse-Yu Pan\n • “Exploring the Potential of Mixed Reality in Enhancing Language Acquisition for EFL Children”, Chia Hsu, Yu-Chieh Sun, Hsin-Yi Wang, Yu-Jung Liu, Yi-Ju (Ariel) Wu, Tse-Yu Pan, Neng-Hao Yu\n"},
          {time: "12:05 ~ 14:00",content: "Lunch Break"},
          {time: "14:00 ~ 15:10",content: "Keynote Talk II",more: " Keynote Speaker: \n • Qijia Shao (Hong Kong University of Science and Technology)"},
          {time: "15:10 ~ 15:30",content: "Coffee Break"},
          {time: "15:30 ~ 16:50",content: "Paper Session II & Discussion",more: " • “More Than Shapes: Tactile Aesthetics Workshop for Visually Impaired”, Mingyu Cui, Chao Yuan, Yujia Liu, Yingying Zheng\n • “Time Chamber: Creating a Virtual Environment for Time Dilation with the Selection of Liking”, Yu-Hsiang Weng, Jih Hsuan Peng, Chia-Hui Lin, Kuan-Yun Chang, Ping-Hsuan Han\n • Experience Sharing and Discussion Among All Authors"},
          {time: "16:50 ~ 17:00",content: "Closing & Best Paper Award Ceremony",more: "Best Paper\n •   TBA"},
        ],
        2023: [
          {time: "9:00 ~ 9:20",content: "Opening"},
          {time: "9:20 ~ 10:30",content: "Keynote Talk I",more: " Keynote Speaker: \n • Ashutosh Dhekne (Georgia Institute of Technology, USA)"},
          {time: "10:30 ~ 10:50",content: "Coffee Break"},
          {time: "10:50 ~ 12:10",content: "Paper Session",more:" •  “Meta Flow Experience: Exploring group mindfulness meditation in the immersive environment with multi senses feedback”, Jih Hsuan Peng, Ping-Hsuan Han, Tung-Hua Yang, Cheng-Ta Yang, Ze-Song Chen, Yi-Min Huang \n  • “Non-Contact Thermal Haptics for VR”, Yida wangyida, Yi-Chao Chen\n • “Toward an Ever-present Extended Reality: Distinguishing Between Real and Virtual”, Anton Nijholt\n • “Experience: Large Scale Indoor Location-based Service in Libraries”, Ling Ma, Runting Zhang, Xiaohua Shi"},
          {time: "12:10 ~ 14:00",content: "Lunch Break"},
          {time: "14:00 ~ 15:10",content: "Keynote Talk II",more: " Keynote Speaker: \n • Pan Hao (Microsoft Research Asia)"},
          {time: "15:10 ~ 15:30",content: "Coffee Break"},
          {time: "15:30 ~ 16:40",content: "Keynote Talk III",more: " Keynote Speaker: \n • Yingying Zhao (Fudan University, China)"},
          {time: "16:40 ~ 16:50",content: "Closing & Best Paper Award Ceremony",more: "Best Paper\n •   “Meta Flow Experience: Exploring Group Mindfulness Meditation in the Immersive Environment with Multi-senses Feedback”, Jih Hsuan Peng, Ping-Hsuan Han, Cheng-Ta Yang, Tung-Hua Yang, Ze-Song Chen, Yi-Min Huang"},
        ],
        2022: [
          {time: "9:00 ~ 9:10",content: "Opening"},
          {time: "9:10 ~ 10:00",content: "Keynote Talk I",more: " Keynote Speaker:\n • Shao-Yi Chien (National Taiwan University, Taiwan & Ganzin Technology, Inc.)"},
          {time: "10:00 ~ 10:05",content: "Coffee Break"},
          {time: "10:05 ~ 11:05",content: " Paper Session",more:" •  “MovableBag: Exploring Asymmetric Interaction for Multi-user Exergame in Extended Reality”, Luis Mendez, Ping-Hsuan Han, Ho Yin Ng \n • “Improve Immersion in Virtual Reality-Based Basketball Training by Haptic Feedback”, Wan-Lun Tsai, Tse-Yu Pan, Min-Chun Hu\n • “Perceptual Modifications in Augmented Reality: A Short Survey”, Anton Nijholt\n • “InertiaVibe: Low-fidelity Simulation of Inertia using Head-mounted Vibrotactile Feedback to Reduce Cybersickness and Enhance VR Experience”, Shih-Yu Ma, Cong Min Lin, Chung-Wei Wang, Neng-Hao Yu, Mike Y. Chen"},
          {time: "11:05 ~ 11:10",content: "Coffee Break"},
          {time: "11:10 ~ 12:00",content: "Keynote Talk II",more: " Keynote Speaker: \n • Mehdi Ammi (University Paris 8, French)"},
          {time: "12:00 ~ 12:10",content: "Closing & Best Paper Award Ceremony",more: "Best Paper\n •   “MovableBag: Exploring Asymmetric Interaction for Multi-user Exergame in Extended Reality”, Luis Mendez, Ping-Hsuan Han, Ho Yin Ng"}
        ],
        2021: [
          {time: "9:00 ~ 9:10",content: "Opening"},
          {time: "9:10 ~ 10:20",content: "Keynote Talk I",more: " Keynote Speaker:\n • Pedro Lopes (University of Chicago, USA)"},
          {time: "10:20 ~ 10:30",content: "Coffee Break"},
          {time: "10:30 ~ 11:10",content: " Paper Session I: Making VR/AR interactions social",more: "  • “CELIP: Ultrasonic-based Lip Reading with Channel Estimation Approach for Virtual Reality Systems”, Yongzhao Zhang, Yi-Chao Chen, Haonan Wang, Xingyu Jin\n • “Experiencing Social Augmented Reality in Public Spaces”, Anton Nijholt"},
          {time: "11:10 ~ 11:30",content: "Coffee Break"},
          {time: "11:30 ~ 12:30",content: "Paper Session II: Realistic AR/VR environment matters",more: "  • “ARToken: A Tangible Device for Dynamically Binding Real-world Objects with Virtual Representation”, Hsuan-Yu Hsueh, Chien-Hua Chen, Irene Chen, Chih-Yuan Yao, Hung-Kuo Chu\n • “CravingProbe: A System Combining Virtual Reality and Biofeedback Technologies to Assist Drug Psychotherapy”, Chieh-Jui Ho, Chi-Ting Hou, Min-Wei Hung, Chien Wen (Tina) Yuan, Nanyi Bi, Ming-Chyi Huang, Chuang-Wen You\n • “Material Identification System with Sound Simulation Assisted Method in VR/AR Scenarios”, Yezhou Wang, Runting Zhang, Haonan Wu, Guangtao Xue"},
          {time: "12:30 ~ 14:00",content: "Lunch Break"},
          {time: "14:00 ~ 15:10",content: "Keynote Talk II",more: " Keynote Speaker: \n • Mike Chen (National Taiwan University, Taiwan)"},
          {time: "15:10 ~ 15:20",content: "Coffee Break"},
          {time: "15:20 ~ 16:00",content: "Paper Session III: Innovative VR/AR Haptic Sensations",more: "  • “High-Speed Non-Contact Thermal Display Using Infrared Rays and Shutter Mechanism”, Sosuke Ichihashi, Arata Horie, Masaharu Hirose, Zendai Kashino, Shigeo Yoshida, Masahiko Inami\n • “Flowing-Haptic Sleeve: Research on Apparent Tactile Motion Applied to Simulating the Feeling of Flow on the Arm”, Hao-Ping Chien, Ming-Cheng Wu, Chun-Cheng Hsu"},
          {time: "16:00 ~ 16:20",content: "Coffee Break"},
          {time: "16:20 ~ 17:20",content: "Panel Discussion: The Future Trends in VR/AR Interactions",more: " Panelists: \n • Andrea Bianchi (KAIST)\n • Liwei Chan (National Yang Ming Chiao Tung University)\n • Min-Chun Hu (National Tsing Hua University)\n • Ray Lee (CORMA New Media)"},
          {time: "17:20 ~ 17:30",content: "Closing & Best Paper Award Ceremony",more: "Best Paper \n •  “High-Speed Non-Contact Thermal Display Using Infrared Rays and Shutter Mechanism”, Sosuke Ichihashi, Arata Horie, Masaharu Hirose, Zendai Kashino, Shigeo Yoshida, Masahiko Inami"}
        ]
      }
    };
  },
  methods: {},
};
</script>

<style scoped>
/* @import "@/style/value.sass" */



table {
  border-collapse: collapse;
  box-shadow: 0 5px 10px #8d9b9a;
  background-color: white;
  text-align: left;
  overflow: hidden;
  width: 100%;
  margin: auto;
  border-radius: 8px;
}
thead {
  box-shadow: 0 5px 10px #8d9b9a;
}

th {
  padding: 1rem 2rem;
  text-transform: uppercase;
  letter-spacing: 0.1rem;
  font-size: 19px;
  font-weight: 900;
}

td {
  padding: 1rem 1.8rem;
  line-height: 25px;
  min-width: 100px;
}
.tableCotent{
    margin: 10px;
}
tr:nth-child(even) {
  background-color: #b8d5d8;
}
</style>



// WEBPACK FOOTER //
// src/components/mainPage/Agenda.vue